import React from 'react';

const BillingIcon: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="3.5"
      width="16"
      height="12.8"
      rx="4"
      stroke="var(--color-primary)"
      strokeWidth="1.5"
    />
    <path
      d="M2 7.9H18"
      stroke="var(--color-primary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.20312 12.7008H9.20313"
      stroke="var(--color-primary)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BillingIcon;
